import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vueConfig from 'vue-config'
import config from './config'



document.addEventListener("DOMContentLoaded", function(event) { 
  Vue.use(vueConfig, config)
  Vue.config.productionTip = true
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})

function updateIndicator(status) {
  if (status && status.type === 'offline') {
    $('.offline-indicator').show()
    $('.offline-order-counter').show()
    console.log('OFFLINE')
    store.state.offline = true
  } else if (status && status.type === 'online') {
    $('.offline-indicator').hide()
    $('.offline-order-counter').hide()

    console.log('ONLINE')
    store.state.offline = false

    // Check if we should sync some data back to the server
    if (window.localStorage.getItem('queue')) {
      console.log('SYNCING')
      var data = JSON.parse(window.localStorage.getItem('queue'))

      data.forEach(function (message) {
        $.ajax({
          url: message.url,
          type: message.method,
          data: message.data,
          dataType: 'json'
        })
      })

      window.localStorage.removeItem('queue')
    }
  }
}

window.addEventListener('online', updateIndicator)
window.addEventListener('offline', updateIndicator)

updateIndicator()

// document.addEventListener("deviceready", function(){
// //   window.plugins.imei.get(
// //   function(imei) {
// //     console.log("got imei: " + imei);
// //     window.localStorage.setItem('imei',imei)
// //   },
// //   function() {
// //     console.log("error loading imei");
// //   }
// // );
// }, false);
